<template>
  <div class="resetPassword">
    <div class="title">
      <van-nav-bar title="设置新密码" left-arrow @click-left="onClickLeft"/>
    </div>

    <van-cell-group>
      <van-field v-model="password" type="password" placeholder="新密码" maxlength="16" />
      <van-field v-model="passwordCheck" type="password" placeholder="确认密码" maxlength="16" />
    </van-cell-group>

    <van-button type="info" @click="resetPassword">完成</van-button>
    <div class="tip">智慧脸收银端和管理端将同步更新该账号密码</div>
    
  </div>
</template>
<script>
import { toast } from '../../components/Toast'
import { updatePassword } from '../../api/index'
import { getCookie } from '@/utils/auth'
import md5 from 'md5'


export default {
  components: {},
  data() {
    return {
      password:'',
      passwordCheck:'',
      employeeId:'',
      isAjaxing:false
    }
  },
  created() {
    this.employeeId = this.db.getItem('employeeId');
    if(!this.employeeId){
      window.location.href = 'protocol://action/logout';
      this.db.removeItem('employeeId');
      this.db.removeItem('drugstoreName');
      return false;
    }
  },
  methods: {
    //完成按钮
    resetPassword(){
      if(this.isAjaxing) return false;
      const regPassword = /^[\da-zA-Z`·\\'~!@#$%^\"&*()|{}:;,\".<>?~\\\\]{6,16}$/
      if(!this.password){
        toast('请输入新密码');
        return false;
      }
      if(!this.passwordCheck){
        toast('请输入确认密码');
        return false;
      }
      if (!this.checkPwd(this.password)) {
        toast('请输入6-16位数字、字母或符号，至少包含以上两种')
        return false;
      }
      if (!this.checkPwd(this.passwordCheck)) {
        toast('请输入6-16位数字、字母或符号，至少包含以上两种')
        return false;
      }
      if(!regPassword.test(this.password)){
        toast('密码格式不支持，请修改后重新提交')
        return false;
      }
      if(!regPassword.test(this.passwordCheck)){
        toast('密码格式不支持，请修改后重新提交')
        return false;
      }
      if(this.password !== this.passwordCheck){
        toast('两次输入的密码不一致，请重试');
        return false;
      }
      this.isAjaxing = true;
      let { employeeId,passwordCheck } = this;
      passwordCheck = md5(passwordCheck);
      updatePassword({ newPassword:passwordCheck,employeeId }).then(res => {
        toast({
          message: '更新成功!',
          onClose: () => {
            window.location.href = 'protocol://action/finish/'
          }
        })
        this.isAjaxing = false;
      }).catch(res => {
        this.isAjaxing = false;
        if(!toast){
          toast(res.msg || res.result || res)
        }
      })
    },
    checkPwd(password){
      if(password.length < 6){
        return false;
      }
      const p1 = /^[A-Za-z]+$/;
      if (p1.test(password)) {//如果全是字母，不可以
          return false;
      }
      const p2 = /^[0-9]+$/;
      if (p2.test(password)) {//如果全是数字，不可以
          return false;
      }
      const p3 = /^[`\\'~!@#$%^\"&*()|{}:;,.<>?~\\\\]+$/;
      if (p3.test(password)) {//如果全是特殊符号，不可以
          return false;
      }
      return true;
    },
    onClickLeft() {
      window.location.href = 'protocol://action/finish/'
    }
  }
}
</script>
<style scoped>
@import '../../styles/search.css';
#app {
  height: 100vh;
}
.resetPassword /deep/.van-nav-bar{height: 64px;line-height: 64px;}
.resetPassword .van-hairline--bottom::after{
    border:none;
}
.resetPassword {
  width: 375px;
  height: 100vh;
  background: #fff;
  position: relative;
  font-size: 14px;
}
.van-button--normal {
  width: 345px;
  height: 35px;
  line-height:35px;
  margin: 0 10px;
  border-radius: 20px;
  margin-top: 40px
}
.tip{
  font-size:12px;
  color:rgba(153,153,153,1);
  line-height:20px;
  text-align: center;
  margin-top: 10px;
}

</style>
